module.exports = __webpack_public_path__ + "img/Slovakia.e8420452.svg";